import React from "react";
import { TTableRow } from "./TableConst";
import TableRow, { TTableRowProps } from "./TableRow";
import { TTableCellProps } from "./TableCell";

export type TTableRowKey<T extends TTableRow> = (row:T) => string|number
export type TTableBodyProps<T extends TTableRow> = Omit<TTableRowProps<T>, "row"> & Omit<TTableCellProps<T>, "col"|"row"> & {
    rows:T[]
    rowKey:(row:T) => string|number
}

export default function TableBody<T extends TTableRow>(props:TTableBodyProps<T>) {
    const rows = props.rows.map(row => <TableRow row={row} cols={props.cols} tr={props.tr} td={props.td} key={props.rowKey(row)} cellValue={props.cellValue} cellText={props.cellText}/>)
    return <tbody>{rows}</tbody>
}